import React from "react";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";

import EnhancferList from "../EnhancferList";
import * as actions from "../../../store/actions";
import * as appsyncOperations from "../../../utils/appsyncOperations";

const UsersTransferDialog = ({
  open,
  onClose,
  divisionId,
  serviceProviderId,
  usersById,
  divisionUserIds,
  everyOtherUserId,
  dispatch,
  enqueueSnackbar,
}) => {
  const [renderEnhancfer, setRenderEnhancfer] = React.useState(false);
  const [updatePending, setUpdatePending] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setRenderEnhancfer(true);
    }
  }, [open]);

  const saveChanges = async ({ right: nextDivisionUserIds }) => {
    setUpdatePending(true);
    const batchUpdateInput = [];
    // Start by determining which users have received division updates.
    const difference = [
      divisionUserIds.filter((userId) => !nextDivisionUserIds.includes(userId)),
      nextDivisionUserIds.filter((userId) => !divisionUserIds.includes(userId)),
    ];
    // Queue user updates for users that had a division removed
    for (const userId of difference[0]) {
      const user = usersById[userId];
      if (user !== undefined) {
        batchUpdateInput.push({
          divisionId,
          relationalId: user.userId,
          operation: "DELETE",
          variant: "USER",
          serviceProviderId,
        });
      }
    }
    // Queue user updates for users that had a division added
    for (const userId of difference[1]) {
      const user = usersById[userId];
      if (user !== undefined) {
        batchUpdateInput.push({
          divisionId,
          relationalId: user.userId,
          operation: "CREATE",
          variant: "USER",
          serviceProviderId,
        });
      }
    }
    try {
      const updatedDivisionRelations = await appsyncOperations.batchWriteDivisionRelations(
        batchUpdateInput
      );
      dispatch(
        actions.divisions.setDivisions({
          divisionRelations: updatedDivisionRelations,
        })
      );
      onClose();
      setUpdatePending(false);
      enqueueSnackbar("Update successful!", { variant: "success" });
    } catch (error) {
      setUpdatePending(false);
      enqueueSnackbar(error, { variant: "error" });
    }
  };
  return (
    renderEnhancfer && (
      <EnhancferList
        title="Select users"
        isOpen={open}
        onClose={onClose}
        onExited={() => setRenderEnhancfer(false)}
        data={usersById}
        leftLabel="Available users"
        initLeft={everyOtherUserId}
        rightLabel="Selected users"
        initRight={divisionUserIds}
        valueExtractor={(user) => user.displayName}
        searchId="userId"
        searchKeys={["displayName"]}
        onSaveHandler={saveChanges}
        loading={updatePending}
      />
    )
  );
};

const mapStateToProps = (state, ownProps) => {
  const division = state.divisions.byId[ownProps.divisionId];
  const divisionUserIds =
    division !== undefined
      ? Object.keys(division.users.byId).filter(
          (userId) => !division.users.byId[userId].isDeleted
        )
      : [];
  return {
    serviceProviderId: state.auth.user.attributes["custom:service_provider_id"],
    usersById: state.users.byId,
    divisionUserIds,
    everyOtherUserId: Object.keys(state.users.byId).filter((userId) => {
      const user = state.users.byId[userId];
      return (
        user !== undefined &&
        !user.isDeleted &&
        !divisionUserIds.includes(userId)
      );
    }),
  };
};

export default withSnackbar(connect(mapStateToProps)(UsersTransferDialog));
